import {Component, model, signal} from '@angular/core';
import {Field, form, FormField} from '@angular/forms/signals';
import {SexSelector} from '../sex-selector/sex-selector';
import {AppBaseComponent} from '../../shared/components/app-base-component/app-base-component';

@Component({
  selector: 'app-search-widget',
  imports: [

    SexSelector,
    FormField
  ],
  templateUrl: './search-widget.html',
  styleUrl: './search-widget.css',
})
export class SearchWidget extends AppBaseComponent {
  formModel = signal({
    age: [18, 40],
    sex: 'female'
  });
  form = form(this.formModel);

  search(e: SubmitEvent) {
    e.preventDefault();
    this.storageService.setItem('sex', this.formModel().sex);
    const type = this.formModel().sex == 'female' ? 'brides' : 'grooms'
    this.router.navigate(['/suggestions/' + type]).then();
  }
}
